/**
 * BehaviorGraph Behavior Editor
 * Summary display and "Open Editor" button for the BehaviorGraph behavior
 */

import React from 'react';
import type { BehaviorGraphData } from 'trace-viewer/behaviors';
import { openBehaviorGraphPopup } from '../behaviorgraph-editor/BehaviorGraphPanel';

export interface BehaviorGraphEditorProps {
    data: BehaviorGraphData;
}

export const BehaviorGraphEditor: React.FC<BehaviorGraphEditorProps> = ({ data }) => {
    const graph = data.graph;
    const nodeCount = graph?.nodes?.length ?? 0;

    return (
        <div style={{ textAlign: 'center', padding: '8px' }}>
            <button
                onClick={openBehaviorGraphPopup}
                style={{
                    padding: '8px 16px',
                    backgroundColor: '#0078d4',
                    border: 'none',
                    borderRadius: '4px',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '13px',
                }}
            >
                Open Graph Editor
            </button>
            <div style={{ fontSize: '11px', color: '#888', marginTop: '8px' }}>
                {nodeCount === 0
                    ? 'Empty graph'
                    : `${nodeCount} node${nodeCount !== 1 ? 's' : ''}`}
            </div>
        </div>
    );
};
